// removed by extract-text-webpack-plugin
module.exports = {"colorPalette":"_2yOVkfIqLCRhGuwCxG5_yc","color":"MxBtJzX1W71gFdq_U7dWq","colorCode":"J0FhfFfYb3l_4mo9R2kyI","normalState":"Egxex4HxMwYn9gN3AXxz4","hoverState":"_3z5OfKoaCSZvXKQsPFF6_9","activeState":"E_K_FhGAOLa-YPPPiI89a","defaultColor":"Y9HpZkxDauBnflyLZcQcR","primaryColor":"uWOIaSxCvnHZjIRoDgHVJ","infoColor":"_2R8soBFzms_V_eTu00qluU","successColor":"_2pB3TOshHLWhpt9wIOdFQT","warningColor":"_2TYYL1VtpV-FPl30C6e9KY","dangerColor":"gcPJsa7IfK9SxL64eW8Zq"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/03-global/colors/color-palette.scss
// module id = 130
// module chunks = 0